import type { NewsItem } from '@/types';

export const newsCategories = ['全部', '影评新闻', '电影动态', '行业分析'];

export const news: NewsItem[] = [
  {
    id: '1',
    title: '第 97 届奥斯卡：韩国电影再度入围最佳国际影片',
    category: '电影动态',
    excerpt: '本届评选中，韩国团队凭借一部聚焦家庭关系的新作再次进入最佳国际影片短名单，引发业内广泛关注。',
    content: [
      '本届评选的短名单公布后，一部聚焦家庭关系的韩国作品成功入围最佳国际影片，成为亚洲电影中备受瞩目的存在。这是韩国电影近年来持续走向国际舞台的又一例证。',
      '影片以细腻的日常观察和克制的叙事风格获得评审青睐，多家海外媒体在评论中提到，它延续了韩国电影一贯的现实关怀传统。',
      '业内人士认为，稳定的创作生态与成熟的产业支持，是韩国电影能够持续产出的重要基础。',
    ],
    author: '编辑部',
    date: '2024-05-18',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20film%20awards%2C%20abstract%20golden%20trophy%20silhouette%20on%20deep%20navy%20background%2C%20elegant%20minimalist%20composition%2C%20no%20text&width=800&height=500&seq=kfilm-news-01&orientation=landscape',
  },
  {
    id: '2',
    title: '影评人年度票选：近十年最值得重看的韩国剧情片',
    category: '影评新闻',
    excerpt: '由四十余位影评人参与的年度票选结果揭晓，多部经典文艺片与类型佳作共同进入榜单。',
    content: [
      '本次票选邀请来自多个地区的影评人共同参与，从叙事、表演、影像风格等维度评选近十年最值得重看的韩国剧情片。',
      '榜单中既有横扫国际影展的作者电影，也有在商业上取得巨大成功的类型作品，体现出韩国电影在艺术与市场之间的独特平衡。',
      '多位参与者提到，重看这些影片时，往往能在细节中发现新的层次。',
    ],
    author: '影评组',
    date: '2024-05-06',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20film%20critics%2C%20abstract%20stacked%20paper%20sheets%20and%20pen%20on%20ivory%20desk%2C%20warm%20amber%20accent%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-02&orientation=landscape',
  },
  {
    id: '3',
    title: '流媒体平台加大对韩国原创剧情的投入',
    category: '行业分析',
    excerpt: '多家国际流媒体宣布扩大韩国原创内容预算，剧情类与作者向作品的比重明显上升。',
    content: [
      '过去几年，韩国影视内容在国际市场表现亮眼，促使各大流媒体平台持续加码本地原创。最新公布的预算中，剧情类与作者向作品的比重明显提高。',
      '分析人士指出，平台策略正从「数量扩张」转向「品质深耕」，更愿意为具有独特作者风格的项目提供空间。',
      '这对独立创作者而言既是机会，也带来了新的创作压力。',
    ],
    author: '产业观察',
    date: '2024-04-22',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20streaming%20industry%2C%20abstract%20glowing%20screen%20panels%20in%20navy%20and%20amber%2C%20minimalist%20tech%20composition%2C%20no%20text&width=800&height=500&seq=kfilm-news-03&orientation=landscape',
  },
  {
    id: '4',
    title: '专访：一位美术指导眼中的韩国电影色彩',
    category: '影评新闻',
    excerpt: '从冷峻的青灰到温暖的琥珀，韩国电影的配色背后，藏着一整套关于情绪的视觉语言。',
    content: [
      '在接受采访时，这位资深美术指导谈到，韩国电影的色彩往往与角色的心理状态紧密相关，而不是单纯追求视觉冲击。',
      '他举例说，很多作品会用冷色调表现疏离，用暖色调标记脆弱的温情，两者之间的切换本身就是叙事的一部分。',
      '「颜色是有记忆的，观众未必说得清，但一定感受得到。」他这样总结。',
    ],
    author: '编辑部',
    date: '2024-04-10',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20film%20color%20design%2C%20abstract%20color%20swatches%20in%20amber%20olive%20and%20navy%2C%20artistic%20minimalist%20composition%2C%20no%20text&width=800&height=500&seq=kfilm-news-04&orientation=landscape',
  },
  {
    id: '5',
    title: '釜山国际电影节公布新一批展映片单',
    category: '电影动态',
    excerpt: '新一届釜山国际电影节的展映片单正式发布，多部新锐导演的长片首作入选。',
    content: [
      '釜山国际电影节公布了新一批展映片单，涵盖亚洲多个国家和地区的新作，其中不乏新锐导演的长片首作。',
      '组委会表示，今年的选片更加注重作者表达的独特性，同时也保留了对社会议题的关注。',
      '多部入围影片的主创将到场参与映后交流。',
    ],
    author: '影展前线',
    date: '2024-03-28',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20film%20festival%2C%20abstract%20seaside%20stage%20with%20warm%20lights%20at%20dusk%2C%20amber%20and%20navy%20tones%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-05&orientation=landscape',
  },
  {
    id: '6',
    title: '从剧本到成片：韩国电影工业的标准化流程',
    category: '行业分析',
    excerpt: '成熟的制片体系、严格的拍摄计划与细致的后期管理，共同构成了韩国电影的产业底座。',
    content: [
      '韩国电影近年来的稳定产出，离不开一套高度标准化的工业流程。从剧本开发、前期筹备到拍摄与后期，每个环节都有专业团队分工协作。',
      '业内人士指出，标准化并不意味着抹杀创作个性，反而为作者导演提供了更可控的创作环境。',
      '这种「工业化 + 作者性」的组合，正是韩国电影的重要经验。',
    ],
    author: '产业观察',
    date: '2024-03-15',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20film%20production%2C%20abstract%20clapperboard%20and%20camera%20geometric%20shapes%2C%20navy%20and%20amber%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-06&orientation=landscape',
  },
  {
    id: '7',
    title: '重映热潮：经典韩国电影如何重回大银幕',
    category: '电影动态',
    excerpt: '多部经典作品以修复版形式重返影院，年轻观众第一次在大银幕上遇见这些影片。',
    content: [
      '近两年，多部经典韩国电影以数字修复版的形式重新上映，吸引了不少年轻观众走进影院。',
      '发行方表示，修复不只是提高画质，更是对影像本身的重新理解，许多细节在高清版本中才第一次被看清。',
      '重映也带动了影迷对经典作品的二次讨论。',
    ],
    author: '编辑部',
    date: '2024-03-02',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20cinema%20rerelease%2C%20abstract%20old%20projector%20beam%20in%20dark%20room%2C%20warm%20amber%20light%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-07&orientation=landscape',
  },
  {
    id: '8',
    title: '长镜头之外：韩国电影的剪辑美学',
    category: '影评新闻',
    excerpt: '除了为人称道的长镜头，韩国电影在剪辑上的节奏控制同样值得细读。',
    content: [
      '谈到韩国电影的技术特点，人们常常先想到长镜头。但事实上，许多作品在剪辑上的节奏控制同样精妙。',
      '影评人指出，好的剪辑并不追求炫技，而是让观众自然地进入角色的情绪节奏，在关键时刻发力。',
      '这种「隐藏的技巧」，正是成熟电影工业的体现。',
    ],
    author: '影评组',
    date: '2024-02-20',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20film%20editing%2C%20abstract%20timeline%20and%20frames%20strip%20in%20navy%20ivory%20and%20amber%2C%20minimalist%20graphic%20composition%2C%20no%20text&width=800&height=500&seq=kfilm-news-08&orientation=landscape',
  },
  {
    id: '9',
    title: '新生代导演群像：他们正在拍什么',
    category: '行业分析',
    excerpt: '一批年轻导演正以更个人化的视角讲述当下的韩国，题材与形式都呈现出新的可能。',
    content: [
      '与前辈相比，新一代韩国导演更倾向于从个体经验出发，关注城市生活、代际关系与身份认同等议题。',
      '他们的作品往往预算有限，却充满实验精神，在各类影展上频频亮相。',
      '评论认为，这股新生力量正在为韩国电影注入新的语言。',
    ],
    author: '产业观察',
    date: '2024-02-08',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20young%20directors%2C%20abstract%20group%20of%20silhouettes%20with%20city%20lights%2C%20navy%20and%20amber%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-09&orientation=landscape',
  },
  {
    id: '10',
    title: '《寄生虫》五周年：它为什么仍在被讨论',
    category: '影评新闻',
    excerpt: '五年过去，这部作品依然频繁出现在各类讨论中，它的生命力来自哪里？',
    content: [
      '距离《寄生虫》上映已过去五年，但这部作品依然频繁出现在影评、课堂与社交讨论之中。',
      '分析认为，它的持久魅力来自精准的社会观察与高度的类型完成度，让不同背景的观众都能找到共鸣。',
      '更重要的是，它提出的问题至今仍未过时。',
    ],
    author: '影评组',
    date: '2024-01-26',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20sociological%20film%2C%20abstract%20concrete%20stairs%20and%20light%20in%20olive%20and%20amber%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-10&orientation=landscape',
  },
  {
    id: '11',
    title: '韩国电影的配乐：情绪如何被听见',
    category: '影评新闻',
    excerpt: '从钢琴独奏到弦乐铺陈，配乐在韩国电影中承担着推动情绪的重要角色。',
    content: [
      '配乐在韩国电影中往往承担着推动情绪的关键作用。许多作品偏爱简洁的钢琴与弦乐，用克制的旋律增强画面的表达。',
      '作曲家在访谈中提到，好的配乐应当「不抢戏」，而是在观众需要的时候出现。',
      '这种分寸感，正是韩国电影音乐的一大特色。',
    ],
    author: '编辑部',
    date: '2024-01-12',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20film%20score%2C%20abstract%20sound%20waves%20and%20piano%20keys%20in%20navy%20and%20amber%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-11&orientation=landscape',
  },
  {
    id: '12',
    title: '演员的转型：从偶像到实力派的路径',
    category: '行业分析',
    excerpt: '越来越多偶像出身的演员通过文艺片与舞台剧完成转型，拓宽了自己的表演边界。',
    content: [
      '在韩国影视圈，偶像出身的演员通过文艺片与舞台剧实现转型，已成为一种常见路径。',
      '业内认为，这类转型需要作品与角色选择的双重积累，急不得。',
      '当观众开始讨论「演技」而非「人气」，转型才算真正完成。',
    ],
    author: '产业观察',
    date: '2023-12-29',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20acting%20transformation%2C%20abstract%20theatre%20curtain%20and%20spotlight%20in%20navy%20and%20amber%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-12&orientation=landscape',
  },
  {
    id: '13',
    title: '跨文化传播：韩国电影在海外为何受欢迎',
    category: '行业分析',
    excerpt: '情感共通、类型成熟与议题普世，是韩国电影走向海外市场的关键因素。',
    content: [
      '韩国电影在海外市场的成功，离不开几个关键因素：情感表达的可共情、类型叙事的成熟，以及议题的普世性。',
      '研究者指出，字幕文化在年轻观众中的普及，也降低了跨语言观看的门槛。',
      '这些因素共同作用，让韩国电影成为全球观众熟悉的文化产品。',
    ],
    author: '产业观察',
    date: '2023-12-16',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20global%20cinema%2C%20abstract%20globe%20made%20of%20light%20dots%20in%20navy%20and%20amber%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-13&orientation=landscape',
  },
  {
    id: '14',
    title: '文学改编的得与失：韩国电影如何转译小说',
    category: '影评新闻',
    excerpt: '当文字变成影像，改编者需要在忠实与再创作之间找到平衡。',
    content: [
      '韩国电影有大量作品改编自小说与短篇，改编者需要面对的共同问题，是如何在忠实原作与影像再创作之间取得平衡。',
      '成功的改编往往抓住原作的精神内核，而非逐字复刻情节。',
      '这也解释了为什么有些改编能被原著读者与影迷同时接受。',
    ],
    author: '影评组',
    date: '2023-12-03',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20literary%20adaptation%2C%20abstract%20open%20book%20turning%20into%20film%20frames%2C%20ivory%20and%20amber%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-14&orientation=landscape',
  },
  {
    id: '15',
    title: '电影修复技术如何还原老片的质感',
    category: '电影动态',
    excerpt: '数字修复让尘封多年的影片重获新生，也带来关于「原貌」的新讨论。',
    content: [
      '数字修复技术让许多尘封多年的老片重新面世，观众得以在清晰画质中重新欣赏经典。',
      '但修复也带来新的讨论：修复到什么程度才算「还原原貌」，是一道需要专业判断的难题。',
      '修复团队表示，尊重导演意图与胶片本身的质感，是工作的基本原则。',
    ],
    author: '编辑部',
    date: '2023-11-20',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20film%20restoration%2C%20abstract%20old%20film%20reel%20and%20digital%20pixels%2C%20sepia%20and%20navy%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-15&orientation=landscape',
  },
  {
    id: '16',
    title: '影展之外：独立电影如何找到观众',
    category: '行业分析',
    excerpt: '影院排片之外，社区放映、线上平台与影迷社群正成为独立电影的重要出口。',
    content: [
      '对于缺少宣发资源的独立电影而言，找到观众始终是最大的挑战。除了影展，社区放映、线上平台与影迷社群正成为越来越重要的出口。',
      '有导演表示，小规模但深入的交流，往往比大范围的曝光更能带来真实的连接。',
      '这种「慢发行」模式，正在被更多人尝试。',
    ],
    author: '产业观察',
    date: '2023-11-07',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20indie%20cinema%2C%20abstract%20small%20screening%20room%20with%20warm%20light%2C%20navy%20and%20amber%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-16&orientation=landscape',
  },
  {
    id: '17',
    title: '历史题材的分寸感：韩国古装片如何讲当下',
    category: '影评新闻',
    excerpt: '优秀的古装片从不只是复述历史，而是借过去回应现在。',
    content: [
      '韩国古装片常常借历史的外壳，讨论与当下相关的问题，这需要创作者把握好分寸感。',
      '影评人指出，当历史成为一面镜子而非布景，作品才能真正与观众产生对话。',
      '这也是近年多部古装作品获得好评的原因之一。',
    ],
    author: '影评组',
    date: '2023-10-25',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20period%20film%2C%20abstract%20palace%20silhouette%20at%20dusk%20in%20deep%20crimson%20and%20gold%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-17&orientation=landscape',
  },
  {
    id: '18',
    title: '幕后：一部韩国电影从立项到上映要多久',
    category: '行业分析',
    excerpt: '从剧本开发到正式上映，一部韩国电影的完整周期往往需要数年时间。',
    content: [
      '一部韩国电影从立项到上映，通常需要经历剧本开发、融资、筹备、拍摄、后期与发行等多个阶段，周期往往长达数年。',
      '制片人表示，越是作者性强的项目，前期打磨的时间越长。',
      '理解这条漫长的链条，有助于观众更立体地看待一部作品的诞生。',
    ],
    author: '产业观察',
    date: '2023-10-11',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20film%20production%20timeline%2C%20abstract%20calendar%20and%20film%20reel%20in%20navy%20and%20amber%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-18&orientation=landscape',
  },
  {
    id: '19',
    title: '女性创作者的崛起：韩国电影的新声',
    category: '行业分析',
    excerpt: '越来越多女性导演与编剧进入行业核心，为韩国电影带来新的叙事视角。',
    content: [
      '近年来，越来越多的女性导演与编剧进入韩国电影行业的核心位置，带来了不同于以往的叙事视角。',
      '她们关注情感、关系与个体的细微处境，拓展了韩国电影的题材边界。',
      '业内认为，创作者的多元化，是产业长期健康发展的重要信号。',
    ],
    author: '产业观察',
    date: '2023-09-27',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20women%20filmmakers%2C%20abstract%20portrait%20silhouette%20with%20soft%20amber%20light%2C%20navy%20background%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-19&orientation=landscape',
  },
  {
    id: '20',
    title: '为什么韩国电影偏爱开放式结局',
    category: '影评新闻',
    excerpt: '不给答案，反而让观众带走问题，开放式结局成为许多韩国电影的共同选择。',
    content: [
      '从《燃烧》到《密阳》，许多韩国电影选择用开放式结局收束故事，把判断权交给观众。',
      '这种处理方式让作品在上映后仍能持续引发讨论，延长了它的生命。',
      '评论认为，这既是美学选择，也体现了创作者对观众的尊重。',
    ],
    author: '影评组',
    date: '2023-09-13',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20news%20image%20about%20open%20ending%2C%20abstract%20open%20door%20with%20light%20beyond%2C%20navy%20and%20amber%2C%20minimalist%2C%20no%20text&width=800&height=500&seq=kfilm-news-20&orientation=landscape',
  },
];